<template>
  <v-dialog 
    v-model="isOpen" 
    persistent 
    max-width="450"
    content-class="download-dialog">
    <v-card>
      <dialog-header text="Download" @closeModal="cancelActiveDownload"/>
      <v-card-text class="pa-5">
        {{activeDownloadText}}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="downloadActiveFile" class="modal-cta">Download</v-btn>
        <v-btn text @click="cancelActiveDownload" class="modal-cta">Cancel</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dialogHeader from "./DialogHeader";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "downloadDialog",
  components: {dialogHeader},
  computed: {
    ...mapGetters(["activeDownloadText", "activeDownloadLink"]),
    isOpen(){
      return !!this.activeDownloadText && !!this.activeDownloadLink;
    }
  },
  methods: {
    ...mapActions(["downloadActiveFile"]),
    ...mapMutations(["cancelActiveDownload"])
  }
}
</script>